import { render, staticRenderFns } from "./GenerateReportPage.vue?vue&type=template&id=6386a1bd"
import script from "./GenerateReportPage.vue?vue&type=script&lang=js"
export * from "./GenerateReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports